module.exports = __webpack_public_path__ + "static/media/Roboto-Medium.90d16760.woff2";